import {
  FinnairItineraryItemFlight,
  FinnairLocation,
  ItineraryItemFlight,
  ItineraryItemLayover,
} from '@fcom/dapi/api/models';
import { isShortHaulFlight } from '@fcom/common/utils';

import { isFlight } from './common-booking.utils';

export const isLongHaulLegAndAy = (
  itineraryArray: (ItineraryItemFlight | ItineraryItemLayover)[],
  location: {
    [key: string]: FinnairLocation;
  }
): boolean => {
  return itineraryArray
    .filter(isFlight)
    .filter((itinerary: FinnairItineraryItemFlight) => itinerary.operatingAirline.code === 'AY')
    .some((itinerary: FinnairItineraryItemFlight) => {
      const departureLocation = itinerary.departure.locationCode;
      const destinationLocation = itinerary.arrival.locationCode;

      const departureCountry = location[departureLocation].countryCode;
      const destinationCountry = location[destinationLocation].countryCode;

      return !isShortHaulFlight(
        { countryCode: departureCountry } as FinnairLocation,
        { countryCode: destinationCountry } as FinnairLocation
      );
    });
};
